import { render, staticRenderFns } from "./EchargeRecord.vue?vue&type=template&id=664d4e0c&scoped=true&"
import script from "./EchargeRecord.vue?vue&type=script&lang=js&"
export * from "./EchargeRecord.vue?vue&type=script&lang=js&"
import style0 from "./EchargeRecord.vue?vue&type=style&index=0&id=664d4e0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d4e0c",
  null
  
)

export default component.exports